import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { topPlatforms } from '@/mocks/platforms';

export default function About() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '樱花视频',
    url: 'https://hongfengyi.cn/',
    description: '樱花视频汇集香蕉视频、红桃视频、蜜桃视频、糖豆视频等同类优质平台，提供高清免费在线观看推荐。',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@hongfengyi.cn',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '樱花视频是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '樱花视频是一个视频平台推荐聚合网站，汇集了香蕉视频、红桃视频、蜜桃视频、糖豆视频等优质在线视频平台，为用户提供全面客观的平台评测和推荐服务。我们帮助用户发现最适合自己的视频平台，享受高清流畅的观影体验。',
        },
      },
      {
        '@type': 'Question',
        name: '樱花视频推荐的平台可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们推荐的每一个平台都经过团队的严格评测。评测维度包括内容资源丰富度、播放流畅度、更新速度、用户体验、安全性等多个方面。我们坚持客观公正的原则，只为用户推荐真正优质的视频平台。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系樱花视频？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过邮箱 contact@hongfengyi.cn 与我们取得联系。我们珍视每一位用户的反馈，无论是平台推荐建议、使用体验分享，还是合作意向，都欢迎随时联系我们。',
        },
      },
      {
        '@type': 'Question',
        name: '樱花视频推荐的平台都是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们推荐的平台以免费观看为主，部分平台可能提供增值会员服务。每个平台的具体收费政策请以平台官方信息为准。樱花视频致力于为用户提供高性价比的观影选择。',
        },
      },
      {
        '@type': 'Question',
        name: '樱花视频会定期更新平台推荐吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，我们的团队会持续关注视频平台行业动态，定期对已推荐平台进行复评，并发现和评测新的优质平台。您可以关注我们的文章栏目，获取最新的平台评测和推荐信息。',
        },
      },
    ],
  };

  const reputations = [
    { name: '用户李先生', rating: 5, text: '通过樱花视频找到了好几个不错的平台，红桃视频追剧体验太好了，推荐系统真的很准！', date: '2025-07-30' },
    { name: '用户王女士', rating: 5, text: '之前一直不知道选哪个平台看动漫，看了樱花视频的评测文章后试了蜜桃视频，动漫资源真的很全，强烈推荐！', date: '2025-07-28' },
    { name: '用户张先生', rating: 5, text: '香蕉视频的电影更新速度确实快，樱花视频的评测很客观，和我实际体验完全一致。', date: '2025-07-25' },
    { name: '用户陈女士', rating: 4, text: '网站界面简洁大方，分类清晰，很快就能找到需要的平台信息。希望能增加更多平台评测。', date: '2025-07-22' },
    { name: '用户刘先生', rating: 5, text: '糖豆视频的短视频功能太赞了，适合通勤时候看。感谢樱花视频的推荐，帮了大忙！', date: '2025-07-20' },
    { name: '用户赵女士', rating: 5, text: '评测文章写得很专业，对比维度清晰明了。特别是播放卡顿那个教程，照着做之后确实好多了。', date: '2025-07-18' },
  ];

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-background-200/70">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="w-full py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
              <div>
                <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
                  关于我们
                </span>
                <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-5 leading-tight">
                  樱花视频 —— 您的<span className="text-primary-500">视频平台</span>推荐专家
                </h1>
                <div className="space-y-4 text-foreground-700 leading-relaxed">
                  <p>
                    <strong>樱花视频</strong>成立于2020年，是国内领先的视频平台推荐聚合网站。我们致力于帮助用户在海量在线视频平台中找到最适合自己的选择，提供<strong>客观、公正、全面</strong>的平台评测与推荐服务。
                  </p>
                  <p>
                    我们的团队由资深的视频行业从业者和技术专家组成，对在线视频平台的技术架构、内容生态和用户体验有着深刻的理解。每一个推荐平台都经过<strong>多维度严格评测</strong>，确保用户能够享受到高清流畅的观影体验。
                  </p>
                  <p>
                    目前，樱花视频已汇集了<strong>香蕉视频、红桃视频、蜜桃视频、糖豆视频</strong>等50余个优质视频平台，涵盖电影、电视剧、动漫、综艺、短视频等多个类别，服务超过500万活跃用户。
                  </p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20creative%20workspace%20with%20designers%20working%20on%20large%20monitors%20displaying%20video%20content%2C%20warm%20coral%20accent%20decor%2C%20natural%20light%20from%20large%20windows%2C%20clean%20organized%20desk%2C%20professional%20yet%20cozy%20atmosphere%2C%20editorial%20photography%20style%20with%20soft%20shadows&width=800&height=600&seq=about-brand-01&orientation=landscape"
                  alt="樱花视频团队工作场景"
                  className="w-full h-auto"
                  title="樱花视频 - 视频平台推荐专家团队"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                我们的使命
              </h2>
              <p className="text-base text-foreground-600 max-w-2xl mx-auto">
                以客观公正的态度，为每一位用户找到最适合的视频平台
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {[
                { icon: 'ri-search-eye-line', title: '发现优质平台', desc: '持续发掘和评测优质在线视频平台，为用户提供丰富的选择。我们的评测团队每周更新平台数据，确保推荐信息的时效性和准确性。' },
                { icon: 'ri-scales-3-line', title: '客观公正评测', desc: '坚持独立客观的评测标准，不受任何商业利益影响。从内容、技术、体验、安全四大维度全面评分，让用户放心选择。' },
                { icon: 'ri-heart-pulse-line', title: '提升观影体验', desc: '帮助用户找到最适合自己的平台，享受高清流畅的观影体验。提供使用教程和安全指南，让观影更省心更安心。' },
              ].map((item) => (
                <div key={item.title} className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 text-center">
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                    <i className={`${item.icon} text-2xl text-accent-600`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Recommended Platforms */}
        <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                推荐平台一览
              </h2>
              <p className="text-base text-foreground-600 max-w-2xl mx-auto">
                以下是樱花视频精选推荐的五大视频平台，每个平台都有独特的优势
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              {topPlatforms.map((platform) => (
                <div key={platform.id} className="text-center group">
                  <div className={`w-16 h-16 mx-auto mb-3 rounded-full bg-gradient-to-br ${platform.color} flex items-center justify-center text-background-50`}>
                    <span className="text-xl font-bold">{platform.name.charAt(0)}</span>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-1">{platform.name}</h3>
                  <div className="flex items-center justify-center gap-1 mb-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    <span className="text-xs font-medium text-foreground-600">{platform.rating}</span>
                  </div>
                  <p className="text-xs text-foreground-500">{platform.category}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation Section */}
        <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                用户口碑
              </h2>
              <p className="text-base text-foreground-600 max-w-2xl mx-auto">
                真实用户的评价是对我们最大的肯定
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {reputations.map((rep) => (
                <div key={rep.name + rep.date} className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < rep.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    &ldquo;{rep.text}&rdquo;
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-foreground-900">{rep.name}</span>
                    <span className="text-xs text-foreground-500">{rep.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              联系我们
            </h2>
            <p className="text-base text-foreground-600 mb-10 max-w-xl mx-auto">
              如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们取得联系
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-600">contact@hongfengyi.cn</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-time-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">工作时间</h3>
                <p className="text-sm text-foreground-600">周一至周五 9:00-18:00</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-chat-3-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">响应时间</h3>
                <p className="text-sm text-foreground-600">24小时内回复</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}